export default {
	namespaced: true,
	// 储存数据
	state: {},
	mutations: {

	},
	// 操作数据
	actions: {
		// WanlShop 初始化，检测
		async init({
			state,
			dispatch,
			rootState
		}) {
			let userStorage = localStorage.getItem('zcyz_userinfo')
			// 已经登录，将原有账户赋值给状态管理器
			if (userStorage) {
				rootState.user = JSON.parse(userStorage);
			} else {
				let user = rootState.user;
				for (let j in user) {
					user[j] = ''
				}
				localStorage.removeItem('zcyz_userinfo')
			}
		},
		// async baseinfo({
		// 	state,
		// 	dispatch,
		// 	rootState
		// }) {
		// 	let userStorage = localStorage.getItem('rcjq_baseinfo')
		// 	// 已经登录，将原有账户赋值给状态管理器
		// 	if (userStorage) {
		// 		rootState.baseinfo = JSON.parse(userStorage);
		// 	} else {
		// 		let user = rootState.baseinfo;
		// 		for (let j in user) {
		// 			user[j] = ''
		// 		}
		// 		// 从本地缓存中异步移除
		// 		localStorage.removeItem('rcjq_baseinfo')
		// 	}
		// }
	}
};